import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneSquareAlt } from '@fortawesome/free-solid-svg-icons';
import { faEnvelopeSquare } from '@fortawesome/free-solid-svg-icons';

export class Contact extends React.PureComponent {
    render() {
        return (
            <section id="contact" className="my-5">
            <div className="contact d-flex justify-content-center align-items-center">
                <h2 className="text-white">Contact</h2>
            </div>
            <div className="container">
                <div className="d-flex flex-row flex-wrap">
                        <div className="d-flex flex-column contactInfo" >
                            <h5 className="mt-2">Info</h5>
                            <p className="w-75 mb-5">Je kan ons elke dag bereiken op onderstaande GSM nummers. Je kan ons ook gewoon een mailtje sturen of het contact formulier invullen. 
                            </p>
                            <div className="d-flex flex-column align-content-center">
                                <div className="d-flex flex-row align-items-center my-2">
                                <FontAwesomeIcon className="fa-3x" icon={ faPhoneSquareAlt }/><span className="px-1 mx-3">+32 (0) 489 98 23 79 (Andor Vrinssen) </span>
                                </div>
                                <div className="d-flex flex-row align-items-center my-2">
                                <FontAwesomeIcon className="fa-3x" icon={ faPhoneSquareAlt }/><span className="px-1 mx-3">+32 (0) 472 23 40 06 (Christo Lappas) </span>
                                </div>
                                <div className="d-flex flex-row align-items-center my-2">
                                <FontAwesomeIcon className="fa-3x" icon={ faEnvelopeSquare }/><span className="px-1 mx-3">complexbjj@gmail.com</span>
                                </div>
                        
                            </div>
                            
                        </div>
                        <div className="d-flex flex-column contactStyle">         
                            <form action="https://formspree.io/complexbjj@gmail.com" method="POST">
                                <label className="mt-4" for="full-name">Uw Naam <small className="text-danger">*</small></label>
                                <input type="text" name="name" id="full-name" placeholder="Name" required=""/>
                                <label className="mt-4" for="email-address">Uw Email <small className="text-danger">*</small></label>
                                <input type="email" name="_replyto" id="email-address" placeholder="email@domain.com" required=""/>
                                <label className="mt-4" for="message">Boodschap <small className="text-danger">*</small></label>
                                <textarea style={{height:200}} type="text" name="message"/>
                                <input className="contactButton mt-3" type="submit" value="Send"/>
                                <small className="text-danger float-right">* vereist</small>
                            </form>
                        </div>
              
               </div>
            </div>

        </section>
        )
    }
}
export default React.memo(Contact)
